import {kebabCase,size,get,set,isEmpty,debounce} from 'lodash';
import React, {useCallback, useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {
    getAllParkers,
    getSurveyQuestions,
    getSurveyResponses,
    setSurveyResponses
} from "../../../../Store/purchase.slice";
import useSurvey from "../../../Common/useSurvey";
import {Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import PurchaseInfo from "../../Common/CartInfo";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import {nanoid} from "@reduxjs/toolkit";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import {getAuthInfo} from "../../../../Store/api.slice";

export function SurveyPage() {
    const history = useHistory();
    const authInfo = useSelector(getAuthInfo);
    const [disabled, setDisabled] = useState(true);
    const surveyQuestions = useSelector(getSurveyQuestions);
    const surveyResponses = useSelector(getSurveyResponses);
    const dispatch = useDispatch();
    const allParkers = useSelector(getAllParkers);
    const purchaseQuestions = surveyQuestions.filter(({type}) => type === 'PURCHASE').map(({structure}) => structure);
    const [responses, respondToPrompt] = useSurvey(purchaseQuestions, (surveyIsComplete) => {
        setDisabled(!surveyIsComplete);
        // if (surveyIsComplete) {
        //     const responses_array = Object.keys(responses).map(key => ({prompt: key, response: responses[key]}));
        //     dispatch(setSurveyResponses(responses_array));
        // }
    }, surveyResponses.reduce((o, {prompt, response}) => set(o, prompt, response), {}));
    const submitForm = useCallback(() => {
        if (!disabled) {
            const responses_array = Object.keys(responses).map(key => ({prompt: key, response: responses[key]}));
            dispatch(setSurveyResponses(responses_array));
            // history.push(size(authInfo) <= 2 ? '/auth' : '/payor');
        }
    }, [disabled, dispatch, responses])
    useEffect(() => {
        if (isEmpty(allParkers)) history.push('/');
        else if (isEmpty(purchaseQuestions) || !isEmpty(surveyResponses)) {
            history.push(size(authInfo) <= 2 ? '/auth' : '/payor');
        }
    }, [allParkers, history, purchaseQuestions, surveyResponses, authInfo]);
    return <Grid container>
        <Grid item xs={12}>
            <LinearProgress variant="determinate" value={40}/>
        </Grid>
        <Grid container spacing={3} item xs={12} md={7}>
            <Box m={3}>
                <Grid item xs={12}>

                    {purchaseQuestions.length === 0 ? <Typography variant='body1'>
                        This rate has no survey. Please continue to the next screen.
                    </Typography> : <Typography variant='h5'>
                        Please answer our quick survey
                    </Typography>}
                </Grid>
                {purchaseQuestions.map((surveyQuestion, i) => {
                    return <SurveyQuestion key={i} surveyQuestion={surveyQuestion} respondToPrompt={respondToPrompt}
                                           surveyResponse={responses[surveyQuestion.prompt] || {}} />
                })}
            </Box>
        </Grid>
        <Grid item xs={12} md={5}>
            <Box m={3}>
                <PurchaseInfo/>
            </Box>
        </Grid>
        <Grid container item xs={12} justify="space-between">
            <Box m={3}>
                <Button size="large" variant="contained" color="secondary"
                        onClick={() => history.goBack()}>Back</Button>
            </Box>
            <Box m={3}>
                <Button size="large" variant="contained" color="primary" disabled={disabled}
                        onClick={submitForm}>Next</Button>
            </Box>
        </Grid>
    </Grid>
}

export default React.memo(SurveyPage);

function SurveyQuestion({surveyQuestion, surveyResponse, respondToPrompt}) {
    const {prompt, type} = surveyQuestion;

    // const surveyResponses = useSelector(getSurveyResponses);
    // const surveyResponse = surveyResponses.find(({prompt}) => surveyQuestion.prompt === prompt) || {};
    const responseValue = !isEmpty(surveyResponse) ? get(surveyResponse, 'response', '') : '';
    const handleRadioChange = event => {
        respondToPrompt(prompt, `${event.target.value}`);
    };

    const handleTextChange = value => {
        respondToPrompt(prompt, value);
    }

    let response_input = <></>;
    switch (type) {
        case 'SELECT': {
            response_input =
                <SurveySelect surveyQuestion={surveyQuestion} initValue={responseValue} respondToPrompt={respondToPrompt}/>;
            break;
        }
        case 'RADIO': {
            response_input = <SurveyRadio surveyQuestion={surveyQuestion} respondToPrompt={respondToPrompt}
                                          handleChange={handleRadioChange} initValue={responseValue}/>
            break;
        }
        case 'TEXT': {
            response_input = <SurveyTextField surveyQuestion={surveyQuestion}  prompt={prompt}
                                              handleTextChange={handleTextChange} initValue={responseValue}/>;
            break;
        }
        default:
            break;
    }
    return <Grid item xs={12}>
        {response_input}
    </Grid>
}

SurveyQuestion.propTypes = {
    surveyQuestion: PropTypes.object,
    surveyResponse: PropTypes.any,
    respondToPrompt: PropTypes.func
}

function SurveySelect({surveyQuestion, initValue, respondToPrompt}) {
    const {prompt, options} = surveyQuestion;
    const [selectedValue, setSelectedValue] = useState(initValue || '')

    const handleChange = event => {
        event.persist();
        respondToPrompt(prompt, event.target.value);
        setSelectedValue(event.target.value);
    }

    const selectedOption = options.find(option => option.response === selectedValue && option.next_question);
    const nextQuestion = selectedOption ?
        <SurveyQuestion surveyQuestion={selectedOption.next_question} respondToPrompt={respondToPrompt}/> : <></>;
    const nid = nanoid();
    return <>
        <FormControl fullWidth>
            <InputLabel id={nid}>{prompt}</InputLabel>
            <Select labelId={nid} value={selectedValue} onChange={handleChange}>
                {options.map((option, i) => <MenuItem value={option.response} key={i}>{option.response}</MenuItem>)}
            </Select>
        </FormControl>
        {nextQuestion}
    </>;
}

function SurveyRadio({surveyQuestion, initValue, respondToPrompt}) {
    const {prompt, options} = surveyQuestion
    const [pickedValue, setPickedValue] = useState(initValue || '')

    const handleChange = event => {
        event.persist();
        respondToPrompt(prompt, event.target.value);
        setPickedValue(event.target.value);
    }
    const pickedOption = options.find(option => option.response === pickedValue && option.next_question);
    let nextQuestion = <></>;
    if (pickedOption) {
        nextQuestion = <SurveyQuestion surveyQuestion={pickedOption.next_question} respondToPrompt={respondToPrompt}/>;
    }
    // set state to false on initial render, since a non response is a valid response
    // return <FormControlLabel control={<Switch onChange={handleChange}/>} label={prompt} />;
    return <>
        <FormControl component="fieldset">
            <FormLabel component="legend">{prompt}</FormLabel>
            <RadioGroup aria-label={prompt} name={kebabCase(prompt)} value={pickedValue} onChange={handleChange}>
                {options.map((o, i) => (
                    <FormControlLabel key={i} value={o.response} control={
                        <Radio checked={pickedValue === o.response}/>
                    } label={o.response}/>
                ))}
            </RadioGroup>
        </FormControl>
        {nextQuestion}
    </>
}

function SurveyTextField({prompt, initValue, handleTextChange}) {
    const [textValue, setTextValue] = useState(initValue || '');
    const handleChange = useCallback(debounce((value) => handleTextChange(value), 500), [handleTextChange]);
    const onChange = (e) => {
        setTextValue(e.target.value);
        handleChange(e.target.value);
    }
    return <TextField fullWidth value={textValue} label={prompt} onChange={onChange}/>
}
